// extracted by mini-css-extract-plugin
export default {"container":"ReturnPolicy_container__ybAlu","heading":"ReturnPolicy_heading__xY2Nx","paragraph":"ReturnPolicy_paragraph__neBf1","image":"ReturnPolicy_image__lMpLU"};